// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".src-Customer-Survey-screens-Components-ReadQuestionCard-OpenTypeField-Style__textarea--vTTWl,.src-Customer-Survey-screens-Components-ReadQuestionCard-OpenTypeField-Style__input--z8ke-{border:1px solid rgba(0,0,0,.15);border-radius:3px;padding:5px;width:100%}.src-Customer-Survey-screens-Components-ReadQuestionCard-OpenTypeField-Style__textarea--vTTWl{min-height:5em}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textarea": "src-Customer-Survey-screens-Components-ReadQuestionCard-OpenTypeField-Style__textarea--vTTWl",
	"input": "src-Customer-Survey-screens-Components-ReadQuestionCard-OpenTypeField-Style__input--z8ke-"
};
export default ___CSS_LOADER_EXPORT___;
